import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal, ModalDialog, Row, Col } from 'react-bootstrap';
import Icon from '../Icon';
import AllergeneIcon from '../Icons/allergeneIcons';

const FaModal = styled(ModalDialog)`
  .modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .modal-body {
    h5 {
      font-size: 14px;
    }

    ul {
      list-style: none;
      padding-left: 10px;

      &.no-padding {
        padding: 0;
      }

      li {
        font-weight: 300;

        & span {
          vertical-align: middle;
        }
      }
    }
  }
`;

const AllergeneIconWrapper = styled.div`
  display: inline-block;
  width: 25px;
  margin-right: 5px;
  text-align: center;
`;

const FaModalTitle = styled.h4`
  font-size: 17px;
  margin: 0;
`;

const NutritionInfoModal = ({ show, onHide, data: article, ...props }) => {
  const getMessages = (key) => {
    switch (key) {
      case 'COLORED':
        return 'Farbstoff';
      case 'PRESERVATIVE':
        return 'Konservierungsstoffe';
      case 'NITRAT':
        return 'Nitrat';
      case 'FLAVOUR':
        return 'Geschmacksverstärker';
      case 'ANTIOXIDANT':
        return 'Antioxidationsmittel';
      case 'FLAVOUR':
        return 'Geschmacksverstärker';
      case 'SULFURIZED':
        return 'geschwefelt';
      case 'BLACKENED':
        return 'geschwärzt';
      case 'WAXED':
        return 'gewachst';
      case 'PHOSPHATE':
        return 'Phosphat';
      case 'MILKPROTEIN':
        return 'Milcheiweiß';
      case 'SWEETENED':
        return 'Süßungsmitteln';
      case 'GLUTEN-WHEAT':
        return 'Getreide (Weizen)';
      case 'GLUTEN-HAFER':
        return 'Getreide (Hafer)';
      case 'GLUTEN-ROGGEN':
        return 'Getreide (Roggen)';
      case 'GLUTEN-GERSTE':
        return 'Getreide (Gerste)';
      case 'GLUTEN-DINKEL':
        return 'Getreide (Dinkel)';
      case 'FISH':
        return 'Fisch';
      case 'CRUSTACEAN':
        return 'Krebstiere';
      case 'SULPHITE':
        return 'Schwefeldioxid & Sulfite';
      case 'CELERY':
        return 'Sellerie';
      case 'MILK':
        return 'Milch';
      case 'SESAME':
        return 'Sesam';
      case 'NUTS-ALMOND':
        return 'Nüsse (Mandeln)';
      case 'NUTS-WALNUTS':
        return 'Nüsse (Walnuss)';
      case 'NUTS-CASHEW':
        return 'Nüsse (Cashew)';
      case 'NUTS-PECAN':
        return 'Nüsse (Pecanuss)';
      case 'NUTS-PARA':
        return 'Nüsse (Paranuss)';
      case 'NUTS-PISTACHIO':
        return 'Nüsse (Pistazie)';
      case 'NUTS-MACADAMIA':
        return 'Nüsse (Macadamia)';
      case 'NUTS-QUEENSLAND':
        return 'Nüsse (Queensland)';
      case 'PEANUTS':
        return 'Erdnüsse';
      case 'HAZELNUT':
        return 'Haselnüsse';
      case 'MOLLUSCS':
        return 'Weichtiere';
      case 'EGGS':
        return 'Eier';
      case 'LUPINES':
        return 'Lupinen';
      case 'MUSTARD':
        return 'Senf';
      case 'SOY':
        return 'Soja';
      default:
        return 'kA';
    }
  };

  if (!article) return null;
  return (
    <Modal dialogAs={FaModal} onHide={onHide} show={show} {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title as={FaModalTitle}>{article.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(article.vegan || article.vegetarian || article.hot) && (
          <>
            <h5>Das Gericht ist</h5>
            <ul className="no-padding">
              {article.vegetarian && (
                <li key={`${article._id}-veggie`}>
                  <AllergeneIconWrapper title="Vegetarisch">
                    <Icon style={{ height: 17 }} name="vegetarian" />
                  </AllergeneIconWrapper>
                  <span>Vegetarisch</span>
                </li>
              )}
              {article.vegan && (
                <li key={`${article._id}-vegan`}>
                  <AllergeneIconWrapper title="Vegan">
                    <Icon style={{ height: 17 }} name="vegan" />
                  </AllergeneIconWrapper>
                  <span>Vegan</span>
                </li>
              )}
              {article.hot && (
                <li key={`${article._id}-hot`}>
                  <AllergeneIconWrapper title="Scharf">
                    <Icon style={{ height: 17 }} name="hot" />
                  </AllergeneIconWrapper>
                  <span>Scharf</span>
                </li>
              )}
            </ul>
          </>
        )}
        {article.allergenes && article.allergenes.length > 0 && (
          <>
            <h5>Allergene</h5>
            <ul className="no-padding">
              {article.allergenes.map((allergene) => (
                <li key={`${article._id}-${allergene}`}>
                  <AllergeneIconWrapper>
                    <AllergeneIcon style={{ height: '20px', maxWidth: '20px' }} name={allergene} />
                  </AllergeneIconWrapper>
                  <span>{getMessages(allergene)}</span>
                </li>
              ))}
            </ul>
          </>
        )}
        {article.additives && article.additives.length > 0 && (
          <>
            <h5>Zusatzstoffe</h5>
            <ul className="no-padding">
              {article.additives.map((additive) => (
                <li key={`${article._id}-${additive}`}>
                  <span>- {getMessages(additive)}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

NutritionInfoModal.propTypes = {
  onHide: PropTypes.func,
  data: PropTypes.object,
  show: PropTypes.bool.isRequired,
};

export default NutritionInfoModal;
